// src/hooks/useChatUI.js
import { useState, useCallback } from 'react'
import usePreferences from '../contexts/PreferencesContext.js'
import usePasteUpload  from './usePasteUpload.js'
import useComments    from './useComments.js'

export default function useChatUI(isOwner) {
  // prefs (if you need modality/model here)
  const { modality, model } = usePreferences()

  // basic inputs
  const [input, setInput]             = useState('')
  const [uploadedImage, setUploadedImage] = useState(null)

  // view modes & comments
  const [viewMode, setViewMode]       = useState('canvas')
  const toggleView = v => {
    setViewMode(v)
    setCommentInput(null)
  }

  // paste → image
  usePasteUpload(setUploadedImage)

  // comments
  const {
    commentInput,
    setCommentInput,
    comments,
    submitComment
  } = useComments()

  return {
    // preferences-based UI (if you use them)
    modality,
    model,

    // chat input
    input,
    setInput,

    // image upload
    uploadedImage,
    setUploadedImage,

    // mode toggle
    viewMode,
    setViewMode,
    toggleView,

    // comments
    commentInput,
    setCommentInput,
    comments,
    onCommentSubmit: submitComment,
  }
}
